// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
.divParamSettingOpenMenu
{
    text-align: right;
    width: 100%;
    height: 28px;
    border-color: red;
    border-width: 0px;
    border-style: var(--debug-border-style);


}


.divFullParamSetting {
    background-color: black;
    
    width: 100%;
    height: calc(100% - 30px);
    display: flex;
    flex-direction: row;

    user-select: none;
    -webkit-user-select: none; /* Safari */
    -moz-user-select: none;    /* Firefox */
    -ms-user-select: none;     /* Internet Explorer/Edge */    
  }



  .divParamSettingOpen {
  
    background-color: #050505;
    top: 0%;
    width: calc(100% - 300px);
    height: 100%;
    transform: rotate(0deg) scale(1,1);
    transition-property: transform width;
    transition-duration: var(--sidebar-transition-duration);

  }



  .divParamSettingRightOpen {
  
    background-color: #050505;
    width: 300px;
    height: 100%;
    transition-property: width background-color;
    transition-duration: var(--sidebar-transition-duration);
  }



  .divParamSettingClose {
  

    top: 0%;
    width: 100%;
    height: 100%;
    border-color: green;
    border-width: 0px;
    border-style: var(--debug-border-style);
    transform: rotate(0deg) scale(1,1);
    transition-property: transform width;
    transition-duration: var(--sidebar-transition-duration);
    

  }



  .divParamSettingRightClose {
  
    
    width: 32px;
    height: 100%;
    transition-property: width background-color;
    transition-duration: var(--sidebar-transition-duration);
  }
  
  .divParamSettingContent
  {
    width: 99%;
    height: calc(100% - 28px);
    background-color: var(--panel-color-background-default);

  }

  .tabsettingsimpletitle
  {
    font-size: 12px;
  }`, "",{"version":3,"sources":["webpack://./src/applications/appcode/appcomponents/appsettings/appsettings.css"],"names":[],"mappings":";AACA;;IAEI,iBAAiB;IACjB,WAAW;IACX,YAAY;IACZ,iBAAiB;IACjB,iBAAiB;IACjB,uCAAuC;;;AAG3C;;;AAGA;IACI,uBAAuB;;IAEvB,WAAW;IACX,yBAAyB;IACzB,aAAa;IACb,mBAAmB;;IAEnB,iBAAiB;IACjB,yBAAyB,EAAE,WAAW;IACtC,sBAAsB,KAAK,YAAY;IACvC,qBAAqB,MAAM,2BAA2B;EACxD;;;;EAIA;;IAEE,yBAAyB;IACzB,OAAO;IACP,yBAAyB;IACzB,YAAY;IACZ,kCAAkC;IAClC,oCAAoC;IACpC,uDAAuD;;EAEzD;;;;EAIA;;IAEE,yBAAyB;IACzB,YAAY;IACZ,YAAY;IACZ,2CAA2C;IAC3C,uDAAuD;EACzD;;;;EAIA;;;IAGE,OAAO;IACP,WAAW;IACX,YAAY;IACZ,mBAAmB;IACnB,iBAAiB;IACjB,uCAAuC;IACvC,kCAAkC;IAClC,oCAAoC;IACpC,uDAAuD;;;EAGzD;;;;EAIA;;;IAGE,WAAW;IACX,YAAY;IACZ,2CAA2C;IAC3C,uDAAuD;EACzD;;EAEA;;IAEE,UAAU;IACV,yBAAyB;IACzB,uDAAuD;;EAEzD;;EAEA;;IAEE,eAAe;EACjB","sourcesContent":["\n.divParamSettingOpenMenu\n{\n    text-align: right;\n    width: 100%;\n    height: 28px;\n    border-color: red;\n    border-width: 0px;\n    border-style: var(--debug-border-style);\n\n\n}\n\n\n.divFullParamSetting {\n    background-color: black;\n    \n    width: 100%;\n    height: calc(100% - 30px);\n    display: flex;\n    flex-direction: row;\n\n    user-select: none;\n    -webkit-user-select: none; /* Safari */\n    -moz-user-select: none;    /* Firefox */\n    -ms-user-select: none;     /* Internet Explorer/Edge */    \n  }\n\n\n\n  .divParamSettingOpen {\n  \n    background-color: #050505;\n    top: 0%;\n    width: calc(100% - 300px);\n    height: 100%;\n    transform: rotate(0deg) scale(1,1);\n    transition-property: transform width;\n    transition-duration: var(--sidebar-transition-duration);\n\n  }\n\n\n\n  .divParamSettingRightOpen {\n  \n    background-color: #050505;\n    width: 300px;\n    height: 100%;\n    transition-property: width background-color;\n    transition-duration: var(--sidebar-transition-duration);\n  }\n\n\n\n  .divParamSettingClose {\n  \n\n    top: 0%;\n    width: 100%;\n    height: 100%;\n    border-color: green;\n    border-width: 0px;\n    border-style: var(--debug-border-style);\n    transform: rotate(0deg) scale(1,1);\n    transition-property: transform width;\n    transition-duration: var(--sidebar-transition-duration);\n    \n\n  }\n\n\n\n  .divParamSettingRightClose {\n  \n    \n    width: 32px;\n    height: 100%;\n    transition-property: width background-color;\n    transition-duration: var(--sidebar-transition-duration);\n  }\n  \n  .divParamSettingContent\n  {\n    width: 99%;\n    height: calc(100% - 28px);\n    background-color: var(--panel-color-background-default);\n\n  }\n\n  .tabsettingsimpletitle\n  {\n    font-size: 12px;\n  }"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
